module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "capitalRecordList",
    on: {
      "click": _vm.clickFn
    }
  }, [_c('div', {
    staticClass: "rows time"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("\n      " + _vm._s(_vm.time) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "rows clear"
  }, [_c('span', {
    staticClass: "Type"
  }, [_vm._v("\n      " + _vm._s(_vm.type) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "Sum",
    class: _vm.sum < 0 ? 'SumRed' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.sum) + "元\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c73fdb9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/capitalRecordList/src/capitalRecordList.vue
// module id = 548
// module chunks = 0